import { adminApi } from '../../api/endpoints'
import { BulkImportPage, Column, type BulkImportConfig } from './BulkImportPage'

/**
 * Bulk student sign-up.
 *
 * <p>The page itself is {@link BulkImportPage}, shared with the tutor import. What is here is only
 * what a seeker's file differs by: the columns a row must carry, and the one thing an admin should
 * know before creating accounts for children.
 */
const CONFIG: BulkImportConfig = {
  title: 'Bulk seeker sign-up',
  intro:
    'Upload a CSV and YellowDots creates a draft account per row - no email is sent and no dot ' +
    'appears yet - unless you tick "Email everyone" below. Otherwise, when you are ready, open the ' +
    'Report status tab, tick who to invite and press Send invitation; each seeker becomes live once they confirm.',
  noun: 'seeker',
  nounPlural: 'seekers',
  templateFilename: 'yellow-dot-seekers.csv',
  columns: (
    <>
      <Column name="full_name" required>the seeker's name</Column>
      <Column name="email" required>where the set-password link goes</Column>
      <Column name="phone" required>ten digits, +91 and spaces are fine</Column>
      <Column name="gender" required>MALE, FEMALE, OTHER, PREFER_NOT_TO_SAY</Column>
      <Column name="address">the full street address - optional</Column>
      <Column name="city" required>e.g. Delhi</Column>
      <Column name="state" required>e.g. Delhi</Column>
      <Column name="pincode" required>six digits, used to place them on the map</Column>
      <Column name="dob" required>YYYY-MM-DD, e.g. 2010-04-15</Column>
      <Column name="category" required>
        what they are looking for - academics, competitive_exams, music, sports, arts, skills,
        ai, languages, school_admission, higher_education or internships
      </Column>
      <Column name="sub_category">
        the specific item within that category, e.g. Mathematics - optional, and must be one of
        the category's own items when given
      </Column>
    </>
  ),
  notice:
    'A seeker under 18 is created but stays gated - they cannot connect to anyone until a ' +
    'parent accepts. The import does not invite parents; the seeker sends that invite ' +
    'themselves from their profile once they have signed in.',
  upload: (file, dryRun, onLine, sendInvites) => adminApi.importStudents(file, dryRun, onLine, sendInvites),
  downloadTemplate: () => adminApi.studentImportTemplate(),
}

export function AdminStudentImportPage() {
  return <BulkImportPage config={CONFIG} />
}
